export const SET_APPROVAL_POPUP = 'SET_APPROVAL_POPUP';
export const APPROVAL_POPUP = 'approved-popup';
export const CONFIRM_POPUP = 'confirm-popup';
